export const BOOKING_STEPS = {
  CHOOSE_TIME: 1,
  REVIEW: 2,
  USER_INFO: 3,
  CONFIRMATION: 4,
};

export type BookingStep = typeof BOOKING_STEPS[keyof typeof BOOKING_STEPS];

export const STEP_CONFIG = [
  { title: "CHOOSE TIME", id: BOOKING_STEPS.CHOOSE_TIME },
  { title: "REVIEW", id: BOOKING_STEPS.REVIEW },
  { title: "YOUR INFO", id: BOOKING_STEPS.USER_INFO },
  { title: "CONFIRMATION", id: BOOKING_STEPS.CONFIRMATION },
];


// Duration options
export const DURATION_OPTIONS = [
  { value: "30", label: "30 mins" },
  { value: "45", label: "45 mins" },
  { value: "60", label: "1 hour" },
  { value: "90", label: "1.5 hours" },
  { value: "120", label: "2 hours" },
];

// User type options
export const USER_TYPE_OPTIONS = [
  { value: "parent", label: "Parent" },
  { value: "student", label: "Student" },
];